var _path, _path2, _rect, _rect2, _rect3, _rect4, _path3, _circle, _path4, _path5, _circle2, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArtErrorData = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 328,
  height: 172,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h328v172H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#EBEFFE",
  fillRule: "evenodd",
  d: "M148.645 42.77c27.513-10.406 57.678-37.451 78.134-16.314 23.609 24.396 15.126 64.575-4.896 91.991-17.799 24.371-49.655 30.598-78.733 22.523-29.98-8.326-60.436-29.622-58.698-60.688 1.531-27.357 38.565-27.82 64.193-37.513Z",
  clipRule: "evenodd"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 70,
  height: 86,
  x: 107.009,
  y: 39.009,
  fill: "#223B90",
  rx: 12
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 70,
  height: 100,
  x: 101,
  y: 32,
  fill: "#3863F0",
  rx: 12
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 45.14,
  height: 8.766,
  x: 111,
  y: 85,
  fill: "#223B90",
  rx: 4.383
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  width: 30.78,
  height: 8.766,
  x: 111,
  y: 101.286,
  fill: "#223B90",
  rx: 4.383
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M123.642 62.707a5.853 5.853 0 0 0 5.853-5.853 5.853 5.853 0 1 0-11.707 0 5.854 5.854 0 0 0 5.854 5.853ZM123.642 65.634c-5.865 0-10.642 3.934-10.642 8.78a.58.58 0 0 0 .585.586h20.114a.58.58 0 0 0 .585-.585c0-4.847-4.777-8.78-10.642-8.78Z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 189.347,
  cy: 99.347,
  r: 28.417,
  fill: "#fff",
  opacity: 0.8,
  transform: "rotate(30 189.347 99.347)"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#F23015",
  d: "M200.631 91.92a1.51 1.51 0 0 0-2.106-.372l-8.59 6.002-6.017-8.593a1.51 1.51 0 0 0-2.106-.372 1.51 1.51 0 0 0-.372 2.107l6.017 8.593-8.593 6.016a1.511 1.511 0 0 0-.371 2.107 1.51 1.51 0 0 0 2.106.371l8.593-6.017 6.017 8.593a1.511 1.511 0 1 0 2.477-1.735l-6.016-8.593 8.592-6.016a1.52 1.52 0 0 0 .369-2.092Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#F23015",
  fillRule: "evenodd",
  d: "M197.38 89.908a3.51 3.51 0 0 1 4.89.864 3.52 3.52 0 0 1-.86 4.877l-6.955 4.87 4.87 6.954a3.512 3.512 0 1 1-5.754 4.029l-4.87-6.954-6.955 4.869a3.51 3.51 0 0 1-4.891-.862 3.51 3.51 0 0 1 .862-4.892l6.955-4.87-4.87-6.954a3.511 3.511 0 0 1 .863-4.892 3.51 3.51 0 0 1 4.891.863l4.871 6.956 6.951-4.857h.002Zm1.145 1.64a1.51 1.51 0 0 1 2.106.371 1.52 1.52 0 0 1-.368 2.092l-8.593 6.016 6.017 8.593a1.512 1.512 0 1 1-2.478 1.735l-6.017-8.593-8.593 6.017a1.51 1.51 0 0 1-2.106-.371 1.511 1.511 0 0 1 .371-2.107l8.593-6.016-6.017-8.593a1.51 1.51 0 0 1 .372-2.107 1.51 1.51 0 0 1 2.106.372l6.017 8.593 8.59-6.002Z",
  clipRule: "evenodd"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 189.347,
  cy: 99.347,
  r: 28.5,
  stroke: "#454545",
  strokeWidth: 5,
  transform: "rotate(30 189.347 99.347)"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#454545",
  d: "m216.596 108.151 30.311 17.5a4 4 0 0 1-4 6.928l-30.311-17.5 4-6.928Z"
})));
export default SvgArtErrorData;